import classnames from 'classnames'
import { REVEAL_TIME_MS } from '../../constants/settings'
import { Hint } from '../../generated'

type Props = {
    value?: string
    status?: Hint
    isRevealing?: boolean
    isCompleted?: boolean
    position?: number
}

export const Cell = ({
    value,
    status,
    isRevealing,
    isCompleted,
    position = 0,
}: Props) => {
    const isFilled = value && !isCompleted
    const shouldReveal = isRevealing && isCompleted
    const animationDelay = `${position * REVEAL_TIME_MS}ms`

    const classes = classnames(
        'w-14 h-14 border-solid border-2 flex items-center justify-center mx-0.5 text-4xl font-bold rounded dark:text-white',
        {
            'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600':
                !status,
            'border-black dark:border-slate-100': value && !status,
            'absent shadowed bg-slate-400 dark:bg-slate-700 text-white border-slate-400 dark:border-slate-700':
                status === Hint.Absent,
            'correct shadowed bg-green-500 text-white border-green-500':
                status === Hint.GoodPosition,
            'present shadowed bg-yellow-500 text-white border-yellow-500':
                status === Hint.BadPosition,
            'cell-fill-animation': isFilled,
            'cell-reveal': shouldReveal,
        }
    )

    return (
        <div className={classes} style={{ animationDelay }}>
            <div className="letter-container" style={{ animationDelay }}>
                {value}
            </div>
        </div>
    )
}
